import { NotificationCategory } from './NotificationCategory';

/**
 * Model representing a single notification received from the API
 */
export default class Notification {
  public id: string;
  public title: string;
  public textTitle: string;
  public textBody: string;
  public category: NotificationCategory;
  public type: string | null;
  public icon: string | null;
  public link: string | null;
  public seen: boolean;
  public timestamp: number;

  constructor(
    id: string,
    title: string,
    text: string,
    category: NotificationCategory,
    type: string | null,
    icon: string | null,
    link: string | null,
    seen: boolean,
    timestamp: number,
  ) {
    this.id = id;
    this.title = title;
    this.textTitle = text.split('<br>')[0];
    this.textBody = text.includes("<br>") ? text.slice(text.indexOf('<br>') + 4) : "";
    this.category = category;
    this.type = type;
    this.icon = icon;
    this.link = link;
    this.seen = seen;
    this.timestamp = timestamp;
  }

  public static examples(): Notification[] {
    let notifications: Notification[] = [];

    for (let i = 0; i < 10; i++) {
      notifications.push(
        new Notification(
          "1", "BTC:USDT Buy Order Executed",
          "Bot GRU24-D3-V4-4h-64 bought BTC on Binance for total of 31.003761499999996 USDT for price of 15737.95 USDT.<br><b>Trade summary:</b><br><b>Date:</b> 06-11-2020 08:00:48<br><b>Market:</b> BTC:USDT<br><b>Side:</b> BUY<br><b>Order type:</b> MARKET<br><b>Price:</b> 15737.95 USDT<br><b>Amount:</b> 0.0019699999999999995 BTC<br><b>Fee:</b> 1.97e-06 BTC<br><b>Bot:</b> GRU24-D3-V4-4h-64<br><b>Current bot token balance:</b> 0.003152369999999998 BTC<br><b>Current bot currency balance:</b> 56.50445799999996 USDT<br><b>Current bot value:</b> 106.11059365179992<br><b>Change since last trade:</b> 35.42954213575333",
          NotificationCategory.Trade, null, null, null, false, 1622055696
        )
      )
    }
    return notifications;
  }
}